import { BoxTitle, BoxSubTitle } from './boxTitle.style';

export default function BoxTitleWrapper(props) {
  return (
    <div style={props.style} >
      {props.title
        ? <BoxTitle className="isoBoxTitle">
          {' '}{props.title}{' '}
        </BoxTitle>
        : ''}
      {props.subtitle
        ? <BoxSubTitle className="isoBoxSubTitle">
          {' '}{props.subtitle}{' '}
        </BoxSubTitle>
        : ''}
    </div>
  );
};
